import Linkify from "linkify-react";
import { Link } from "react-router-dom";

interface LinkCreatorProps {
  line: string;
}

export default function LinkCreator(props: LinkCreatorProps) {
  function getFileName(url: string) {
    if (url.includes(".pdf") || url.includes(".docx")) {
      let urlParts = url.split("/")
      return decodeURIComponent(urlParts[3].split("?")[0])
    }
    return url
  }

  return (
    <Linkify
      options={{
        render: {
          url: ({ attributes, content }) => {
            return (
              <a {...attributes} target="_blank">
                {getFileName(content)}
              </a>
            );
          },
          mention: ({ attributes, content }) => {
            const { href, ...props } = attributes;
            return (
              <Link to={href} {...props}>
                {getFileName(content)}
              </Link>
            );
          },
        },
      }}
    >
      {props.line}
    </Linkify>
  );
}
